export const getWebAppUrl = (): string => {
  // Check if we're running locally or in production based on the current URL
  const isProduction = !window.location.hostname.includes('localhost');
  
  return isProduction 
    ? 'https://app.thedefinedcrm.com' 
    : 'http://localhost:3000';
};